import { FileTransferRowParams } from '../../interfaces/file-transfer-row';

export const SubmitForm = async (
  id: string,
  values: FileTransferRowParams,
  recaptcha: string,
  csrfToken: string
): Promise<Response | undefined> => {
  const data = { id, ...values, recaptcha, csrfToken };

  try {
    const response = await fetch('/api/submit', {
      body: JSON.stringify(data),
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) throw new Error('Invalid data');

    return response;
  } catch (error) {
    console.log(error);
  }
};
